<section class="flex flex-col items-center justify-start gap-16 w-full min-h-screen p-5 lg:p-10 xl:p-16">
  <div
    class="flex flex-col text-4xl md:text-8xl lg:text-18xl xl:text-22xl font-secondary font-extrabold">
    <h1 i18n="@@autopark.location.title" class="text-secondary-650 text-center max-w-[1500px]">
      Poznaj największe aspekty <br>
        <span class="text-primary-500">
          Placu Depozytowego ProcessWay
        </span>
      </h1>
  </div>
  <div
    class="w-full mx-auto max-w-[1500px] map-accordion">
    <div class="flex mb-4 gap-2 justify-end">
      <p-button (onClick)="activeIndex = '0'" [rounded]="true" label="1" styleClass="w-8 h-8 p-0"
                [outlined]="activeIndex !== '0'"/>
      <p-button (onClick)="activeIndex = '1'" [rounded]="true" label="2" styleClass="w-8 h-8 p-0"
                [outlined]="activeIndex !== '1'"/>
      <p-button (onClick)="activeIndex = '2'" [rounded]="true" label="3" styleClass="w-8 h-8 p-0"
                [outlined]="activeIndex !== '2'"/>
      <p-button (onClick)="activeIndex = '3'" [rounded]="true" label="4" styleClass="w-8 h-8 p-0"
                [outlined]="activeIndex !== '3'"/>
    </div>

    <p-accordion [(value)]="activeIndex" class="w-full">
      <p-accordion-panel value="0">
        <p-accordion-header class="hover:!bg-secondary-700/5 rounded-md">
          <p class="font-secondary text-primary-500 font-bold text-xl">
            {{ mapSteps()[0]?.label }}
          </p>
        </p-accordion-header>
        <p-accordion-content>
          <div
            class="relative w-full h-[70vh] inline-flex items-start justify-between pt-10 rounded-[1.5rem] bg-secondary-100 shadow-xl">
            <div
              class="absolute z-10 top-0 left-0 max-w-[90%] sm:max-w-[70%] lg:max-w-[50%] h-fit flex flex-col items-start justify-start p-5 md:p-10">
              <h4
                class="text-secondary-700 font-secondary font-bold text-md sm:text-2xl md:text-6xl lg:text-8xl leading-normal lg:leading-relaxed text-left">
                {{ mapSteps()[0]?.title }}
              </h4>
              <p class="text-primary-500 text-xs md:text-base lg:text-lg leading-relaxed text-left">
                {{ mapSteps()[0]?.content }}
              </p>
            </div>
            <div #autoParkMap
                 class="w-full h-full z-0 mask-b-from-80% mask-b-to-90% mask-t-from-70% mask-t-to-100% mask-l-from-90% mask-l-to-100% mask-r-from-90% mask-r-to-100%"></div>
          </div>
        </p-accordion-content>
      </p-accordion-panel>
      <p-accordion-panel value="1">
        <p-accordion-header class="hover:!bg-secondary-700/5 rounded-md">
          <p class="font-secondary text-primary-500 font-bold text-xl">
            {{ mapSteps()[1]?.label }}
          </p>
        </p-accordion-header>
        <p-accordion-content>
          <div
            class="relative w-full h-[70vh] inline-flex items-start justify-between pt-10 rounded-[1.5rem] bg-secondary-100 shadow-xl">
            <div
              class="absolute z-10 top-0 left-0 max-w-[90%] sm:max-w-[70%] lg:max-w-[50%] h-fit flex flex-col items-start justify-start p-5 md:p-10">
              <h4
                class="text-secondary-700 font-secondary font-bold text-md sm:text-2xl md:text-6xl lg:text-8xl leading-normal lg:leading-relaxed text-left">
                {{ mapSteps()[1]?.title }}
              </h4>
              <p class="text-primary-500 text-xs md:text-base lg:text-lg leading-relaxed text-left">
                {{ mapSteps()[1]?.content }}
              </p>
            </div>
            <div #warsawBoundariesMap
                 class="w-full h-full z-0 mask-b-from-80% mask-b-to-90% mask-t-from-70% mask-t-to-100% mask-l-from-90% mask-l-to-100% mask-r-from-90% mask-r-to-100%"></div>
          </div>
        </p-accordion-content>
      </p-accordion-panel>
      <p-accordion-panel value="2">
        <p-accordion-header class="hover:!bg-secondary-700/5 rounded-md">
          <p class="font-secondary text-primary-500 font-bold text-xl">
            {{ mapSteps()[2]?.label }}
          </p>
        </p-accordion-header>
        <p-accordion-content>
          <div
            class="relative w-full h-[70vh] inline-flex items-start justify-between pt-10 rounded-[1.5rem] bg-secondary-100 shadow-xl">
            <div
              class="absolute z-10 top-0 left-0 max-w-[90%] sm:max-w-[70%] lg:max-w-[50%] h-fit flex flex-col items-start justify-start p-5 md:p-10">
              <h4
                class="text-secondary-700 font-secondary font-bold text-md sm:text-2xl md:text-6xl lg:text-8xl leading-normal lg:leading-relaxed text-left">
                {{ mapSteps()[2]?.title }}
              </h4>
              <p class="text-primary-500 text-xs md:text-base lg:text-lg leading-relaxed text-left">
                {{ mapSteps()[2]?.content }}
              </p>
            </div>
            <div #metroMap
                 class="w-full h-full z-0 mask-b-from-80% mask-b-to-90% mask-t-from-70% mask-t-to-100% mask-l-from-90% mask-l-to-100% mask-r-from-90% mask-r-to-100%"></div>
          </div>
        </p-accordion-content>
      </p-accordion-panel>
      <p-accordion-panel value="3">
        <p-accordion-header class="hover:!bg-secondary-700/5 rounded-md">
          <p class="font-secondary text-primary-500 font-bold text-xl">
            {{ mapSteps()[3]?.label }}
          </p>
        </p-accordion-header>
        <p-accordion-content>
          <div
            class="relative w-full h-[70vh] inline-flex items-start justify-between pt-10 rounded-[1.5rem] bg-secondary-100 shadow-xl">
            <div
              class="absolute z-10 top-0 left-0 max-w-[90%] sm:max-w-[70%] lg:max-w-[50%] h-fit flex flex-col items-start justify-start p-5 md:p-10">
              <h4
                class="text-secondary-700 font-secondary font-bold text-md sm:text-2xl md:text-6xl lg:text-8xl leading-normal lg:leading-relaxed text-left">
                {{ mapSteps()[3]?.title }}
              </h4>
              <p class="text-primary-500 text-xs md:text-base lg:text-lg leading-relaxed text-left">
                {{ mapSteps()[3]?.content }}
              </p>
            </div>
            <div #highWayMap
                 class="w-full h-full z-0 mask-b-from-80% mask-b-to-90% mask-t-from-70% mask-t-to-100% mask-l-from-90% mask-l-to-100% mask-r-from-90% mask-r-to-100%"></div>
          </div>
        </p-accordion-content>
      </p-accordion-panel>
    </p-accordion>
  </div>
</section>
